export default (_, inject) => {
  inject('postMessage', (action, value, callbackName, sourceOrigin = '*') => {
    parent.postMessage(
      {
        type: 'xw-game-website',
        action,
        value,
        callbackName
      },
      sourceOrigin
    )
  })
  inject('parseMessageData', (event) => {
    try {
      const data =
        typeof event.data === 'object' ? event.data : JSON.parse(event.data)
      return [null, data]
    } catch (error) {
      return [error, null]
    }
  })
}
